export default __webpack_public_path__ + "static/media/copy.1e6f65d9.svg";